module.exports = __webpack_public_path__ + "static/media/calendar.da2cd332.svg";